import * as faker from 'faker';

export function MockHawb() { return Array( 10 ).fill(0).map( _ => faker.datatype.number( 9 )).join(''); }
